import { Box, BoxProps } from "@mui/material";
import { ReactNode } from "react";

type QuizProtectiveSurfaceProps = BoxProps & {
  children: ReactNode;
};

/**
 * Reduces casual copy/context-menu extraction of quiz content. Not a security boundary
 * (screenshots, DevTools, disabled JS, etc. still bypass this).
 */
export function QuizProtectiveSurface({
  children,
  sx,
  ...rest
}: QuizProtectiveSurfaceProps) {
  return (
    <Box
      onContextMenu={(e) => e.preventDefault()}
      onCopy={(e) => e.preventDefault()}
      onCut={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
      sx={{
        userSelect: "none",
        WebkitUserSelect: "none",
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}
